export default __webpack_public_path__ + "static/media/sdg17_debt_treemap.5f7796bd.png";